export const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    revealWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    actionButtons: {
        display: 'flex',
        gap: 1,
    },
    actionButton: {
        flex: 1,
    },
    contentBox: {
        p: 2,
        alignItems: 'center',
        bgcolor: 'background.default',
        borderRadius: 1,
        border: `1px solid `,
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'space-between',
    },
    fileContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        p: 3,
        bgcolor: 'background.default',
        borderRadius: 2,
        border: `1px solid `,
        borderColor: 'divider',
    },
    jsonContainer: {
        p: 2,
        // bgcolor: mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100],
        borderRadius: 1,
        // border: `1px solid ${theme.palette.divider}`,
        overflow: 'auto',
        maxHeight: 400,
    },
    jsonCode: {
        fontFamily: 'monospace',
        fontSize: '0.875rem',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        // color: theme.palette.text.primary,
        margin: 0,
    },
    credentialsFields: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
    },
    totpSection: {
        // color: theme.palette.text.secondary,
        textAlign: 'center',
    },
};
